'use strict';

var trackingUtils = require('../../modules/utils/tracking.utils.js');
var templateSelectorsViewMixin = require('./utils/template_selector.view.mixin');
var filterViewMixin = require('./utils/filter.view.mixin');
var filterModelMixin = require('./utils/filter.model.mixin');
var filterModelProps = require('./utils/model_props');
var filterMixin = require('./utils/filter.mixin.js');
var changeUIRange = function(data, isFilterAvailable) {
    var $cachedSelectors = this.$cachedSelectors;
    var options = this.widget.options;

    this.updateVisibility(isFilterAvailable);
    if (isFilterAvailable) {
        var unit = options.unitLetter || 'h';
        var $label = this.$cachedSelectors.filter.find('.duration');

        $cachedSelectors.slider.trigger('change-attr', {
            'max': data.boundaryMaxStopDuration,
            'min': data.boundaryMinStopDuration,
            'max-bound': data.maxStopDuration,
            'min-bound': data.minStopDuration,
            'to': data.selectedStopDuration,
        });

        $label.html(data.selectedStopDuration + unit);
    }
    return isFilterAvailable;
};

Odigeo.defineWidget('stopover_duration_old_filter', Odigeo.Widget.extend(Odigeo._.defaults({
    modelClass: Odigeo.Model.extend(Odigeo._.defaults({
        modelProps: filterModelProps.stopoverDuration,
        defaults: {
            maxStopoversSelected: Infinity,
        },
        getRequestModel: function() {
            var filterModel = {};
            filterModel.selectedDuration = this.widget.view.$cachedSelectors.slider.attr('to');
            return filterModel;
        },
    }, filterModelMixin)),

    viewClass: Odigeo.View.extend(Odigeo._.defaults({
        resetFilter: function() {
            this.updateVisibility(true);
        },

        initFilter: function() {
            var data = this.model.toJSON();
            var noStopovers = data.maxStops < 1;
            var isFilterAvailable = !noStopovers && data.minStopDuration < data.maxStopDuration;
            changeUIRange.call(this, data, isFilterAvailable);
        },

        updateFilter: function(idx, fMetadata) {
            var filterModelStopDuration = fMetadata.filterModelStopDuration;
            var data = Odigeo._.pick(fMetadata, this.model.modelProps);
            var isNonStopSelected = this.model.get('maxStopoversSelected') < 1;
            var noStopovers = data.maxStops < 1;
            var isFilterAvailable;

            if (filterModelStopDuration) {
                data.selectedStopDuration = filterModelStopDuration.selectedDuration;
            }

            isFilterAvailable = !isNonStopSelected && !noStopovers &&
                data.boundaryMinStopDuration < data.boundaryMaxStopDuration &&
                data.selectedStopDuration <= data.boundaryMaxStopDuration;

            changeUIRange.call(this, data, isFilterAvailable);

            this.setIsFiltered(idx, data);
        },

        setIsFiltered: function(idx, fMetadata) {
            var isFilterAvailable = fMetadata.maxStops > 0 && fMetadata.minStopDuration < fMetadata.maxStopDuration;
            var result = this.model.get('maxStopoversSelected') < Infinity ||
                (isFilterAvailable && fMetadata.maxStopDuration !== fMetadata.selectedStopDuration);

            Odigeo.trigger(this.widget.widgetType + ':filtersUpdated', idx, 'stopover_duration_filter', result);
        },

        updateVisibility: function(isFilterAvailable) {
            var $el = this.$el;
            var $cachedSelectors = this.$cachedSelectors;
            $el.toggleClass('od-stopduration-disabled', !isFilterAvailable);

            $cachedSelectors.filter.find('.od-ui-range')
                .toggleClass('disabled', !isFilterAvailable)
                .find('input').prop('disabled', !isFilterAvailable);

            $cachedSelectors.slider.trigger(isFilterAvailable ? 'enable' : 'disable');
        },

        onFilter: function(id) {
            var idx = parseInt(id.substr(-1), 10) + 1;
            var label = idx + '_segment_stops_max_duration_' + Odigeo.Utils.pad(this.$widget.find('#' + id).attr('to'), 2);

            this.model.filterRequest(['stopduration']);
            trackingUtils.trackEvent('results_filters', label, 'flights_results');
        },

        updateFilterLabels: function(params) {
            var $label = this.getFilterLabelElement(params);
            if ($label) {
                $label.html($label.html().replace(/\d+/, params.toValue));
            }
        },

        getFilterLabelElement: function(params) {
            if (this.selectors.slider === '#' + params.id) {
                return this.$cachedSelectors.filter.find('div');
            }
        },

        templateSelectors: {
            slider: '#sDurationSelectedSlider${idx}',
            filter: '#sDurationSelected${idx}',
        },
    }, templateSelectorsViewMixin, filterViewMixin)),

    updateMaxStopoversSelected: function(maxStopoversSelected) {
        this.model.set('maxStopoversSelected', maxStopoversSelected);
    },

    bindEvents: function() {
        var view = this.view;
        Odigeo.on('ui-range:doneThumbDrag', function(params) {
            if (view.selectors.slider === '#' + params.id) {
                view.updateFilterLabels(params);
            }
        });
    },

    filterType: 'stopover-duration',

}, filterMixin)));
